export default __webpack_public_path__ + "static/media/asraLogo.79076c45.png";